module.exports = __webpack_public_path__ + "static/media/laptop-sell.b77f667d.png";